module.exports = __webpack_public_path__ + "static/top.4dd74a1486568d4a4d1e1b62ec7beae3.svg";